angular.module('b2bLoginApp.controllers').controller('NotFoundController',
    function() {

    });
